import React from "react";
import { motion } from "framer-motion";
import { Map, Wifi, Zap, Building } from "lucide-react";

const InfrastructureGIS = ({ data }) => {
    if (!data || data.length === 0) return null;

    const getIcon = (category) => {
        if (category.toLowerCase().includes("broadband") || category.toLowerCase().includes("fiber")) return <Wifi size={20} />;
        if (category.toLowerCase().includes("building")) return <Building size={20} />;
        return <Zap size={20} />;
    };

    return (
        <div className="mt-8">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-purple-50 rounded-lg text-purple-600">
                    <Map size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">Infrastructure & GIS (2026)</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {data.map((item, i) => (
                    <motion.div
                        key={i}
                        whileHover={{ scale: 1.02 }}
                        className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex gap-4"
                    >
                        <div className="p-3 bg-gray-50 rounded-2xl h-fit text-gray-400">
                            {getIcon(item.category)}
                        </div>
                        <div>
                            <p className="text-xs text-gray-400 font-semibold uppercase mb-1">{item.metric || item.category}</p>
                            <h4 className="text-xl font-bold text-gray-900 mb-1">
                                {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
                            </h4>
                            <p className="text-xs text-purple-600 font-medium italic opacity-75">{item.trend}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default InfrastructureGIS;
